import { MortgageInterface } from '@app/interfaces/mortgage.interface';

export class FillingScore2000 {
    static check(mortgage: MortgageInterface): boolean {
        return !!(
            mortgage.modelations &&
            mortgage.modelations.length &&
            mortgage.modelations.some((m) => m.variants.length) &&
            mortgage.modelations.some((m) => m.variants.length && m.variants.some((v) => v.isConfirmed))
        );
    }
}
